<template>
    <ul class="tabs">
        <slot></slot>
    </ul>
</template>

<script>
	export default {
		name: "ResponsiveTabsList",
	}
</script>



// WEBPACK FOOTER //
// src/components/common/tabs/TabsList.vue